import React from "react"
import { OAS3ComponentWrapFactory } from "../helpers"

export default OAS3ComponentWrapFactory((props) => {
  const { Ori } = props

  return <span>
    <Ori {...props} />
    <small style={{ backgroundColor: "#89bf04" }}>
      <pre className="version">OAS3</pre>
    </small>
  </span>
})



// WEBPACK FOOTER //
// ./src/core/plugins/oas3/wrap-components/version-stamp.jsx